var axios = require('axios');
export var initNumberFormatSetting = function (column) {
    column.getElement().querySelectorAll('.ac-column-setting--number_format').forEach(function (setting) {
        new NumberFormat(column, setting);
    });
};
var NumberFormat = /** @class */ (function () {
    function NumberFormat(column, setting) {
        this.column = column;
        this.setting = setting;
        this.bindEvents();
    }
    NumberFormat.prototype.bindEvents = function () {
        var _this = this;
        this.refreshPreview();
        this.setting.querySelectorAll('input').forEach(function (el) {
            el.addEventListener('change', function () { return _this.refreshPreview(); });
        });
    };
    NumberFormat.prototype.refreshPreview = function () {
        var _this = this;
        this.getExampleRequest().then(function (response) {
            _this.setting.querySelectorAll('[data-preview]').forEach(function (el) { return el.textContent = response.data.data; });
        });
    };
    NumberFormat.prototype.getValue = function () {
        var decimals = this.setting.querySelector('.ac-setting-input_number_decimals');
        var decimal_point = this.setting.querySelector('.ac-setting-input_number_decimal_point');
        var thousands_point = this.setting.querySelector('.ac-setting-input_number_thousands_separator');
        return {
            decimals: decimals ? decimals.value : '',
            decimal_point: decimal_point ? decimal_point.value : '',
            thousands_point: thousands_point ? thousands_point.value : '',
        };
    };
    NumberFormat.prototype.getExampleRequest = function () {
        var value = this.getValue();
        var data = new FormData();
        data.set('action', 'ac_number_format');
        data.set('number', '7500');
        data.set('decimals', value.decimals);
        data.set('decimal_point', value.decimal_point);
        data.set('thousands_sep', value.thousands_point);
        return axios.post(ajaxurl, data, {});
    };
    return NumberFormat;
}());
